import React from 'react'
import createReactClass from 'create-react-class';
import i18n from 'live/services/i18n'
import xhr from 'live/services/xhr'
import StatsBase from 'live/components/extensions/ui/stats'

var View = createReactClass({
    getInitialState: function () {
        return ({
            instance: {}
        });
    },
    UNSAFE_componentWillMount: function () {
        this.fetch(this.props.id);
    },
    UNSAFE_componentWillReceiveProps: function (newProps) {
        var id = newProps.id;
        var currentId = this.props.id;

        if (id != currentId)
            this.fetch(id);
    },
    fetch: function (id) {
        xhr.get('/rest/extension/' + id).then(this.setInstance);
    },
    setInstance: function (resp) {
        this.setState({
            instance: resp.data
        });
    },
    render: function () {
        var instance = this.state.instance;
        var info = [{
            label: i18n('Output URL'),
            value: instance.config && instance.config.endpoint
        }];

        return (
            <StatsBase {...this.props} noFetch={true} instance={instance} info={info}/>
        );
    }
});

module.exports = View;

